<main *ngIf="offerDetails$ | async as offerDetails">
  <div class="logo-container">
    <img src={{offerDetails.borrower.loanOfficer.companyLogoUrl}} alt="Best Offer Package Logo">
  </div>

  <div class="letter-title">
    <span>Conditional Loan Approval</span>
  </div>

  <div class="letter-content">
    <div class="date">{{ currentDate | date:'longDate' }}</div>
    <!-- <div class="name">Dear {{ offerDetails.borrower.nickname }},</div> -->
   
    <div class="name">Dear {{offerDetails.borrower.fullName}}{{offerDetails.borrower.coBorrower.fullName?(' and ' + offerDetails.borrower.coBorrower.fullName):''}}, </div> 
    
   

    <div class="congratulations">
      <p class="congratulations-section">
        Congratulations! Thank you for choosing {{offerDetails.offer.loanOfficer.companyName}} to represent you in
        securing your mortgage financing. We are confident we can provide
        you with the most efficient home loan process available.
      </p>
      We have reviewed your income, assets, credit and are pleased to inform you that we
      have <strong>approved</strong> your request.
    </div>

    <div class="pre-approval">
      <p class="pre-approval-title">Below is a summary of your pre-approval:</p>
      <div class="pre-approval-info">
        <div class="row">
          <span class="title">Purchase Price:</span>
          <span class="value">{{ offerDetails.offer.price | currency }}</span>
        </div>
        <div class="row">
          <span class="title">Address:</span>
          <span class="value">
            {{offerDetails.offer.address}} {{offerDetails.offer.city}} {{offerDetails.offer.state}} {{offerDetails.offer.zip}}
          </span>
        </div>
        <div class="row">
          <span class="title">Down Payment:</span>
          <span *ngIf="offerDetails.offer.downPaymentType === downPaymentTypes.Percent; else currency">
              {{ offerDetails.offer.downPayment }}%
            </span>
          <ng-template #currency>
            {{ offerDetails.offer.downPayment | currency }}
          </ng-template>
        </div>
        <div class="row">
          <span class="title">Property Type:</span>
          <span class="value">{{ toReadablePropertyType(offerDetails.offer.propertyType) }}</span>
        </div>
        <div class="row">
          <span class="title">Occupancy:</span>
          <span class="value">{{ toReadableOccupancy(offerDetails.borrower.preApproval.occupancy) }}</span>
        </div>
        <div class="row">
          <span class="title">FICO:</span>
          <span class="value">{{ offerDetails.borrower.preApproval.fico }}</span>
        </div>
        <div class="row">
          <span class="title">Program:</span>
          <span class="value">{{ toReadableProgramType(offerDetails.borrower.preApproval.program) }}</span>
        </div>
      </div>
    </div>

    <div class="conditions">
      <p>This approval is subject to the following conditions: </p>
      <p>1.)&nbsp; Satisfactory Appraisal Report </p>
      <p>2.)&nbsp; Issuance of Title and Hazard Insurance satisfactory to our company </p>
      <p>3.)&nbsp; Satisfaction of any special conditions as required </p>
    </div>

    <div class="contacts">
      Please do not hesitate to contact me directly at {{ offerDetails.borrower.loanOfficer.phoneNumber }} with any
      questions
      regarding this approval.
    </div>

    <div class="conclusion">
      <p class="conclusion-section">
        We look forward to servicing your future real estate financing needs and the needs of
        your friends, family, and colleagues.
      </p>
    </div>
    <div class="summary-signatures">
      Thank you,
      <span class="image" *ngIf="offerDetails.offer.loanOfficerOfferSignature as loanOfficerOfferSignature">
        <img [src]="loanOfficerOfferSignature" alt="Loan officer offer signature">
      </span>
      <span class="lo-name">
        {{ offerDetails.borrower.loanOfficer.fullName }}
      </span>
    </div>
    <!-- <div class="company-name">Arbor Financial Group</div> -->
    <div class="company-name">{{offerDetails.offer.loanOfficer.companyName}}</div>
    <div class="company-contacts">
      <div>{{offerDetails.offer.loanOfficer.email}}</div>
      <div>{{offerDetails.offer.loanOfficer.phoneNumber}}</div>
    </div>
  </div>
</main>